import { MenuItem, Stack, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';

export const ContractVersionEmptyMenuItem: React.FC = () => (
  <MenuItem
    sx={{
      minWidth: '176px',
      height: '141px',
      paddingTop: '4px',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'default',
      gap: '4px',
      '&.Mui-disabled': {
        opacity: '1 !important',
        color: 'inherit',
      },
    }}
    disabled
  >
    <Stack
      direction="column"
      sx={{
        alignItems: "center",
        gap: 1
      }}>
      <VyIcon
        icon="ReloadWarning"
        transform="scale(1.2)"
        style={{
          color: '#00D8CB',
        }}
      />
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 700,
          lineHeight: "17px"
        }}>
        Version control
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 400,
          lineHeight: "17px",
          width: "142px",
          textAlign: 'center',
          wordBreak: 'break-word',
          whiteSpace: 'normal'
        }}>
        Once you create another version, all contract versions will appear here
      </Typography>
    </Stack>
  </MenuItem>
);
